import axios from "axios";
import { getJwt } from "../helpers/jwt";
import utils from "../helpers/utils";
import i18next from "i18next";

function isTokenInvalid(r) {
  console.log(r);
  if (r.response && r.response.status === 401) {
    localStorage.removeItem("user_jwt");
  } else if (r.response && r.response.status === 403) {
    alert(i18next.t("messages.access_forbidden"));
  }
}

const baseUrl = utils.defaultUrl();

const pagesActions = {
  validateUser: (props) => {
    const token = getJwt();
    if (!token) {
      props.history.push("/login");
    }
  },
  login: (email, password, callback, t) => {
    axios.post(baseUrl + "/api/authenticate", {
      username: email,
      password: password
    })
      .then(function(response) {
        callback({
          status: "OK",
          msg: {
            message: i18next.t("messages.user_logged_successfully"),
            type: "success",
            jwtToken: response.data.id_token,
            user: response.data.userData.username,
            perms: response.data.userData.perms
          }
        });
      })
      .catch(function(error) {
        console.log(error);
        isTokenInvalid(error);
        callback({
          status: "ERROR",
          msg: {
            message: i18next.t("messages.login_data_incorrect"),
            type: "error"
          }
        });
      });
  },

};


export default pagesActions;
